import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { User } from "../../types/User";
import api from "../../utils/api";

interface LabDetailsState {
  lab: User | null;
  labs: User[];
  isLoading: boolean;
  error?: string;
}

const initialState: LabDetailsState = {
  lab: null,
  labs: [],
  isLoading: false,
  error: undefined,
};

export const fetchLabByToken = createAsyncThunk(
  "lab/fetchLabByToken",
  async (token: string, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/auth/admin/lab-details`,
        {
          params: { token },
        }
      );
      return res.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch lab"
      );
    }
  }
);

export const fetchPartnerLabDetails = createAsyncThunk(
  "partnerLab/fetchPartnerLabDetails",
  async (token: string, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/auth/admin/partner-lab-details/${token}`
      );
      return res.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch partner labs"
      );
    }
  }
);

const labDetailsSlice = createSlice({
  name: "labDetails",
  initialState,
  reducers: {
    clearLab(state) {
      state.lab = null;
      state.error = undefined;
    },
    clearPartnerLabs(state) {
      state.labs = [];
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabByToken.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(fetchLabByToken.fulfilled, (state, action) => {
        state.lab = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchLabByToken.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isLoading = false;
      })
      .addCase(fetchPartnerLabDetails.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(fetchPartnerLabDetails.fulfilled, (state, action) => {
        state.labs = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchPartnerLabDetails.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isLoading = false;
      });
  },
});

export const { clearLab, clearPartnerLabs } = labDetailsSlice.actions;
export default labDetailsSlice.reducer;